import React from "react";
import PropTypes from "prop-types";

import { FormField, SelectFormField } from "../../../../../../utils/FormFields";
import JuridicalPersonLegalAddress from "../LegalAddress";
import JuridicalPersonFiscalResidence from "../FiscalReference";
import { getLocalDate, toDateTime } from "../../../../../../utils/dateUtils";

function JuridicalPersonProfile({ person, changedPerson }) {
  const showPerson = changedPerson || person;
  return (
    <React.Fragment>
      {showPerson.JuridicalPersonLegalName !== undefined && (
        <FormField
          label="Legal Name: "
          value={showPerson.JuridicalPersonLegalName}
          name="JuridicalPersonLegalName"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PersonIsMinimal !== undefined && (
        <SelectFormField
          label="Person is minimal: "
          value={showPerson.PersonIsMinimal}
          name="PersonIsMinimal"
          changedColor={changedPerson}
          selectItems={[
            { id: "true", desc: "Yes" },
            { id: "false", desc: "No" },
          ]}
          getSelectItemId={(i) => i.id}
          getSelectItemName={(i) => i.desc}
        />
      )}
      <FormField label="Type: " value={showPerson.PersonType} name="PersonType" />
      {showPerson.JuridicalPersonConstDate !== undefined && (
        <FormField
          label="Constitution Date"
          type="date"
          value={toDateTime(showPerson.JuridicalPersonConstDate)}
          name="JuridicalPersonConstDate"
          changedColor={changedPerson}
        />
      )}
      {showPerson.JuridicalPersonConstPlace !== undefined && (
        <FormField
          label="Constitution Place"
          value={showPerson.JuridicalPersonConstPlace}
          name="JuridicalPersonConstPlace"
          changedColor={changedPerson}
        />
      )}
      {showPerson.JuridicalPersonDocumentTypeName !== undefined && (
        <FormField
          label="Document Type"
          value={showPerson.JuridicalPersonDocumentTypeName}
          name="JuridicalPersonDocumentTypeName"
          changedColor={changedPerson}
        />
      )}
      {showPerson.JuridicalPersonTAXId !== undefined && (
        <FormField
          label="TAX Id"
          value={showPerson.JuridicalPersonTAXId}
          name="JuridicalPersonTAXId"
          changedColor={changedPerson}
        />
      )}
      {showPerson.JuridicalPersonSecurityNumber !== undefined && (
        <FormField
          label="Security Number"
          value={showPerson.JuridicalPersonSecurityNumber}
          name="JuridicalPersonSecurityNumber"
          changedColor={changedPerson}
        />
      )}
      {showPerson.JuridicalPersonIssuePlace !== undefined && (
        <FormField
          label="Issue Place"
          value={showPerson.JuridicalPersonIssuePlace}
          name="JuridicalPersonIssuePlace"
          changedColor={changedPerson}
        />
      )}
      {showPerson.JuridicalPersonRegFinalBeneficiaries !== undefined && (
        <FormField
          label="is required to register in the registry of final beneficiaries? Law 10.484"
          value={showPerson.JuridicalPersonRegFinalBeneficiaries}
          name="JuridicalPersonRegFinalBeneficiaries"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PersonEmail !== undefined && (
        <FormField
          label="Email:"
          value={showPerson.PersonEmail}
          name="PersonEmail"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PersonCompanyLinkId !== undefined && (
        <FormField
          label="Company Link"
          value={showPerson.PersonCompanyLinkName}
          name="PersonCompanyLinkId"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PersonProfessionId !== undefined && (
        <FormField
          label="Profession"
          value={showPerson.PersonProfessionName}
          name="PersonProfessionId"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PersonActivitySectorId !== undefined && (
        <FormField
          label="Activity Sector"
          value={showPerson.PersonActivitySectorName}
          name="PersonActivitySectorId"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PersonAnualIncome !== undefined && (
        <FormField
          label="Anual Income"
          value={showPerson.PersonAnualIncome}
          name="PersonAnualIncome"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PersonAnualExtraIncome !== undefined && (
        <FormField
          label="Anual Extra Income"
          value={showPerson.PersonAnualExtraIncome}
          name="PersonAnualExtraIncome"
          changedColor={changedPerson}
        />
      )}
      {showPerson.JuridicalPersonSocietyTypeDescription !== undefined && (
        <FormField
          label="Society Type: "
          value={showPerson.JuridicalPersonSocietyTypeDescription}
          name="JuridicalPersonSocietyTypeId"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PersonStatus !== undefined && (
        <FormField
          label="Status: "
          type="status"
          value={showPerson.PersonStatus}
          name="PersonStatus"
          changedColor={changedPerson}
        />
      )}

      {showPerson.PersonFiscalResidence !== undefined &&
        person &&
        person.PersonFiscalResidence != null &&
        changedPerson &&
        changedPerson.PersonFiscalResidence != null &&
        changedPerson.PersonFiscalResidence.length > 0 && (
          <PhysicalPersonFiscalResidence person={person} changedPerson={changedPerson} />
        )}
    </React.Fragment>
  );
}

JuridicalPersonProfile.propTypes = {
  person: PropTypes.object.isRequired,
  changedPerson: PropTypes.object,
};

JuridicalPersonProfile.defaultProps = {
  changedPerson: undefined,
};

export default JuridicalPersonProfile;
